import { render, staticRenderFns } from "./ScrollHorizontal.vue?vue&type=template&id=b934bcc2&scoped=true&lang=pug&"
import script from "./ScrollHorizontal.vue?vue&type=script&lang=js&"
export * from "./ScrollHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./ScrollHorizontal.vue?vue&type=style&index=0&id=b934bcc2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b934bcc2",
  null
  
)

export default component.exports